// extracted by mini-css-extract-plugin
export default {"flaga":"FlagIcon_flaga__Vht3-","skrot":"FlagIcon_skrot__Ge9Vi"};